import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'atividade-tipo',
      component: LayoutPadrao,
      children: [
         {
            path: '/atividade-tipo',
            name: 'atividade-tipo',
            component: () => import('../pages/lista-atividade-tipo/listar-atividade-tipo.vue')
         }
      ]
   },
   {
      path: '/',
      redirect: 'atividade-tipo',
      component: LayoutPadrao,
      children: [
         {
            path: '/atividade-tipo/:id',
            name: 'atividade-tipo-editar',
            component: () => import('../pages/cadastrar-atividade-tipo/cadastrar-atividade-tipo.vue')
         }
      ]
   }
]
